import React from 'react';
import { Button, InputLabel, FormControl, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, SelectChangeEvent } from '@mui/material/';
import LitigationDeadline from '../dataObjects/LitigationDeadline';
import FilterCriteria from '../dataObjects/FilterCriteria';
interface Props {
    currentRecord: LitigationDeadline | null;
    isEditing: boolean;
    openDialog: boolean;

    handleCloseDialog: () => void;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSave: () => Promise<void>;

    filterCriteria: FilterCriteria;
    errors: {
        name: { error: boolean, helperText: string },
        cpfId: { error: boolean, helperText: string },
    }

}

const EditOrAddNewLitigationDeadline = (props: Props) => {
    const resolutionStatusOptions = [
        { id: 0, name: 'Outstanding' },
        { id: 1, name: 'Filed After Referral' },
        { id: 2, name: 'Filed After Complaint' },
    ];

    const reportTypes = [
        { id: 10, name: "Initial Report (D102)" },
        { id: 11, name: "Year-End Report (D102)" },
        { id: 12, name: "Dissolution Report (D102)" },
        { id: 13, name: "Other Report (D102)" },
        { id: 14, name: "Transition-Out Report" },
        { id: 15, name: "Transition-In Report" },
        { id: 16, name: "Year-End Report (D102-L)" },
        { id: 20, name: "Pre-primary Report (ND)" },
        { id: 21, name: "Pre-election Report (ND)" },
        { id: 22, name: "Pre-primary Report (Special) (ND)" },
        { id: 23, name: "Pre-election Report (Special) (ND)" },
        { id: 24, name: "Year-end Report (ND)" },
        { id: 25, name: "Dissolution Report (ND)" },
        { id: 26, name: "Post-election Report (ND)" },
        { id: 27, name: "Other Report (ND)" },
        { id: 28, name: "Mid-Year Report (ND)" },
        { id: 29, name: "Transition Report" },
        { id: 30, name: "Pre-primary Report (PAC)" },
        { id: 31, name: "Pre-election Report (PAC)" },
        { id: 32, name: "Year-end Report (PAC)" },
        { id: 33, name: "Dissolution Report (PAC)" },
        { id: 34, name: "Other Report (PAC)" },
        { id: 35, name: "Mid-Year Report (PAC)" },
        { id: 36, name: "Year-end Report (IEPAC)" },
        { id: 37, name: "Dissolution Report (IEPAC)" },
        { id: 40, name: "Initial Report (BQ)" },
        { id: 41, name: "60th Day Preceding Election Report (BQ)" },
        { id: 42, name: "Sept 20th Report (BQ)" },
        { id: 43, name: "Oct 5th Report (BQ)" },
        { id: 44, name: "Oct 20th Report (BQ)" },
        { id: 45, name: "Year-end Report (BQ)" },
        { id: 46, name: "Dissolution Report (BQ)" },
        { id: 47, name: "Other Report (BQ)" },
        { id: 48, name: "Nov 5th Report (BQ)" },
        { id: 49, name: "Nov 20th Report (BQ)" },
        { id: 50, name: "Pre-primary Report (WTC)" },
        { id: 51, name: "Pre-election Report (WTC)" },
        { id: 52, name: "Year-end Report (WTC)" },
        { id: 53, name: "Dissolution Report (WTC)" },
        { id: 54, name: "Other Report (WTC)" },
        { id: 55, name: "Pre-primary Report (Special) (WTC)" },
        { id: 56, name: "Pre-election Report (Special) (WTC)" },
        { id: 60, name: "Deposit Report" },
        { id: 61, name: "Late Contribution Report" },
        { id: 62, name: "Segregated Account Report" },
        { id: 63, name: "Subvendor Report" },
        { id: 64, name: "IEPAC Report" },
        { id: 65, name: "Payroll Itemization Report" },
        { id: 66, name: "Bank Expenditure Itemization Report" },
        { id: 70, name: "Bank Report (Entire Month)" },
        { id: 71, name: "Bank Report (Days 1-15)" },
        { id: 72, name: "Bank Report (Days 16-End)" },
        { id: 80, name: "Credit Card Report" },
        { id: 90, name: "Reimbursement Report" },
        { id: 110, name: "Pre-preliminary Report" },
        { id: 111, name: "Pre-election Report (MUN)" },
        { id: 113, name: "Year-end report (MUN)" },
        { id: 114, name: "Dissolution Report (MUN)" },
        { id: 115, name: "Other Report (MUN)" }
    ];

    const handleSelectChange = (event: SelectChangeEvent<number>) => {
        const selectedResolutionStatus = resolutionStatusOptions.find(option => option.id === event.target.value);

        if (selectedResolutionStatus) {
            const syntheticEventId = {
                target: {
                    name: 'resolutionStatus',
                    value: selectedResolutionStatus.id.toString(),
                },
            } as React.ChangeEvent<HTMLInputElement>;

            props.handleInputChange(syntheticEventId);
        }
    };

    return (
        <div>
            <Dialog open={props.openDialog} onClose={props.handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{props.isEditing ? 'Edit Filer Record' : 'Add New Filer Record'}</DialogTitle>
                <DialogContent>
                    <TextField name="name" label="Name" value={props.currentRecord?.name || ''} onChange={props.handleInputChange} fullWidth margin="normal" error={props.errors.name.error} helperText={props.errors.name.helperText} />
                    {!props.filterCriteria.isLocal && <TextField name="cpfId" label="CPF ID" value={props.currentRecord?.cpfId || ''} onChange={props.handleInputChange} fullWidth margin="normal" error={props.errors.cpfId.error} helperText={props.errors.cpfId.helperText} />}
                    <TextField name="referredToAGODateString" label="Date Referred to AGO" value={props.currentRecord?.referredToAGODateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <TextField name="agoLetterSentDateString" label="Date AGO Letter Sent" value={props.currentRecord?.agoLetterSentDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    <TextField name="deadlineForResponseAGOString" label="AGO Deadline for Response" value={props.currentRecord?.deadlineForResponseAGOString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    {!props.filterCriteria.isLocal && <TextField name="mailedToSheriffDateString" label="Mailed to Sheriff Date" value={props.currentRecord?.mailedToSheriffDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="complaintFiledDateString" label="Complaint Filed Date" value={props.currentRecord?.complaintFiledDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="servedDateString" label="Date Served" value={props.currentRecord?.servedDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="returnedBySheriffDateString" label="Date Returned by Sheriff" value={props.currentRecord?.returnedBySheriffDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="proofOfServiceDateString" label="Date Proof of Service Provided to Court" value={props.currentRecord?.proofOfServiceDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="notifiedSOOrClerkDateString" label="Notified SOS/Clerk Date" value={props.currentRecord?.notifiedSOOrClerkDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="trackingOrderMailedToDDateString" label="Tracking Order Mailed to D" value={props.currentRecord?.trackingOrderMailedToDDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="trackingOrderMailedToCourtDateString" label="Tracking Order Mailed to Court" value={props.currentRecord?.trackingOrderMailedToCourtDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="answerDueDateString" label="Date Answer Due" value={props.currentRecord?.answerDueDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="answerFiledDateString" label="Date Filed" value={props.currentRecord?.answerFiledDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="mtnEnterDefaultFiledDateString" label="Mtn Enter Default Filed Date" value={props.currentRecord?.mtnEnterDefaultFiledDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="hearingDateString" label="Date of Hearing" value={props.currentRecord?.hearingDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    {!props.filterCriteria.isLocal && <TextField name="defaultEnteredDateString" label="Default Entered Date" value={props.currentRecord?.defaultEnteredDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                    <TextField name="reportFiledDateString" label="Report Filed Date" value={props.currentRecord?.reportFiledDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />
                    {!props.filterCriteria.isLocal && <TextField name="notifiedSOOrClerkReportDateString" label="Notified SOS/Clerk Report Date" value={props.currentRecord?.notifiedSOOrClerkReportDateString || ''} onChange={props.handleInputChange} fullWidth margin="normal" />}
                </DialogContent>

                <DialogActions>
                    <Button onClick={props.handleCloseDialog}>Cancel</Button>
                    <Button onClick={props.handleSave} color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditOrAddNewLitigationDeadline;